module.exports = __webpack_public_path__ + "static/media/intro.74bbcb0a.mp3";